var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m34.679 28.014 3.535 3.535c6.511-6.51 17.062-6.51 23.57 0l3.538-3.535c-8.464-8.463-22.179-8.463-30.643 0z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.333 43.333C83.333 24.922 68.415 10 50 10c-18.41 0-33.333 14.922-33.333 33.333A6.667 6.667 0 0 0 10 50v20a6.667 6.667 0 0 0 6.667 6.667h10A3.332 3.332 0 0 0 30 73.333V56.667c0-1.833-.832-4.584-1.849-6.107l-4.817-7.226c0-14.73 11.938-26.667 26.667-26.667 14.733 0 26.667 11.937 26.667 26.667L71.85 50.56C70.833 52.083 70 54.834 70 56.667v17.598c-4.886 5.55-12.024 9.068-20 9.068h-6.667V90H50c10.898 0 20.54-5.251 26.621-13.333h6.712A6.667 6.667 0 0 0 90 70V50a6.667 6.667 0 0 0-6.667-6.667z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveSupport);
export default __webpack_public_path__ + "static/media/live-support.43af04bcd5522191885842cf9a3c9b4c.svg";
export { ForwardRef as ReactComponent };